import React, { useState } from 'react';
import { Modal } from '../../admin/Modal';

interface EditClientPhaseModalProps {
  isOpen: boolean;
  onClose: () => void;
  currentPhase: number;
  onSelect: (newPhase: number) => void;
}

const phaseDescriptions: Record<number, string> = {
  0: 'Initial onboarding and monitoring phase',
  1: 'Early program with guided progression',
  2: 'Intermediate program with increased autonomy',
  3: 'Advanced program with all goals available'
};

export const EditClientPhaseModal: React.FC<EditClientPhaseModalProps> = ({
  isOpen,
  onClose,
  currentPhase,
  onSelect
}) => {
  const [selectedPhase, setSelectedPhase] = useState<number>(currentPhase);

  const handleSave = () => {
    onSelect(selectedPhase);
  };

  const renderPhaseOption = (phase: number) => {
    const isCurrent = currentPhase === phase;
    const isSelected = selectedPhase === phase;

    return (
      <label
        key={phase}
        style={{
          display: 'flex',
          alignItems: 'flex-start',
          padding: '14px',
          border: '2px solid var(--border)',
          borderRadius: '8px',
          cursor: isCurrent ? 'not-allowed' : 'pointer',
          marginBottom: '12px',
          backgroundColor: isSelected ? 'var(--primary-light)' : 'transparent',
          borderColor: isSelected ? 'var(--primary)' : 'var(--border)',
          transition: 'all 0.2s ease',
          boxShadow: isSelected ? '0 0 0 3px rgba(37, 99, 235, 0.1)' : 'none',
          opacity: isCurrent ? 0.5 : 1
        }}
      >
        <input
          type="radio"
          name="client-phase"
          value={phase}
          checked={isSelected}
          onChange={() => setSelectedPhase(phase)}
          disabled={isCurrent}
          style={{
            marginRight: '12px',
            marginTop: '3px',
            width: '18px',
            height: '18px',
            cursor: isCurrent ? 'not-allowed' : 'pointer',
            accentColor: 'var(--primary)'
          }}
        />
        <div>
          <strong
            style={{
              display: 'block',
              marginBottom: '4px',
              color: isCurrent
                ? 'var(--text-secondary)'
                : isSelected
                ? 'var(--primary)'
                : 'var(--text-primary)',
              fontSize: '15px'
            }}
          >
            Phase {phase} {isCurrent && '(Current)'}
          </strong>
          <span style={{ fontSize: '13px', color: 'var(--text-secondary)' }}>
            {phaseDescriptions[phase]}
          </span>
        </div>
      </label>
    );
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Change Client Phase"
      variant="info"
      size="small"
      footer={
        <>
          <button className="btn btn-secondary" onClick={onClose}>
            Cancel
          </button>
          <button className="btn btn-primary" onClick={handleSave}>
            Continue
          </button>
        </>
      }
    >
      <div style={{ marginBottom: '16px' }}>
        <p style={{ color: 'var(--text-secondary)', marginBottom: '16px' }}>
          Current phase: <strong>Phase {currentPhase}</strong>
        </p>
        <p style={{ fontSize: '13px', color: 'var(--text-muted)', marginBottom: '16px' }}>
          Select the new program phase for this client:
        </p>
      </div>

      <div style={{ marginBottom: '8px' }}>
        {[0, 1, 2, 3].map((phase) => renderPhaseOption(phase))}
      </div>
    </Modal>
  );
};
